
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Yuab", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $18fe68633f55c83c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $18fe68633f55c83c$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "T\xfdm \u2022 50\xa0a\xa0v\xedce \u010Dlen\u016F",
    'fabric.elements.mentions.team.member.50plus.including.you': "T\xfdm \u2022 50\xa0a\xa0v\xedce \u010Dlen\u016F v\u010Detn\u011B v\xe1s",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {T\xfdm \u2022 1 \u010Dlen} few {T\xfdm \u2022 {0} \u010Dlenov\xe9} many {T\xfdm \u2022 {0} \u010Dlena} other {T\xfdm \u2022 {0} \u010Dlen\u016F}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {T\xfdm \u2022 1 \u010Dlen v\u010Detn\u011B v\xe1s} few {T\xfdm \u2022 {0} \u010Dlenov\xe9 v\u010Detn\u011B v\xe1s} many {T\xfdm \u2022 {0} \u010Dlena v\u010Detn\u011B v\xe1s} other {T\xfdm \u2022 {0} \u010Dlen\u016F v\u010Detn\u011B v\xe1s}}",
    'fabric.elements.mentions.xproduct.mention.description': "Pot\u0159ebuje p\u0159\xedstup ke Confluence.",
    'fabric.mention.error.defaultAction': "Zkuste to znovu za p\xe1r sekund",
    'fabric.mention.error.defaultHeadline': "N\u011Bco se pokazilo",
    'fabric.mention.error.differentText': "Zkuste zadat jin\xfd text",
    'fabric.mention.error.loginAgain': "Zkuste se odhl\xe1sit a znovu p\u0159ihl\xe1sit",
    'fabric.mention.noAccess.label': "\u017D\xe1dn\xfd p\u0159\xedstup",
    'fabric.mention.noAccess.warning': "U\u017Eivatel {name} nebude informov\xe1n, proto\u017Ee nem\xe1 p\u0159\xedstup",
    'fabric.mention.unknow.user.error': "Nezn\xe1m\xfd u\u017Eivatel {userId}"
};

});


//# sourceMappingURL=cs.956703b3.js.map
